import { useEffect, useState } from "react";
import { Plus } from "lucide-react";
import { useBrandsStore } from "@/stores/brands";
import { Button } from "@/components/ui/button";
import { AddBrandForm } from "./AddBrandForm";
import { BrandsTable } from "./BrandsTable";
import { EditBrandModal } from "./EditBrandModal";
import type { Brand } from "../../../types";

export function BrandsView() {
  const fetch = useBrandsStore((s) => s.fetch);
  const [showForm, setShowForm] = useState(false);
  const [editingBrand, setEditingBrand] = useState<Brand | null>(null);

  useEffect(() => {
    fetch();
  }, []);

  return (
    <div className="space-y-6">
      {/* Actions Bar */}
      <div className="flex items-center justify-end">
        <Button onClick={() => setShowForm(!showForm)}>
          <Plus className="w-4 h-4 mr-1.5" />
          Add Brand
        </Button>
      </div>

      {/* Collapsible Add Form */}
      {showForm && (
        <div className="animate-fade-up">
          <AddBrandForm onSuccess={() => setShowForm(false)} />
        </div>
      )}

      {/* Table */}
      <BrandsTable onEdit={setEditingBrand} />

      {/* Edit Modal */}
      <EditBrandModal
        brand={editingBrand}
        open={!!editingBrand}
        onOpenChange={(open) => { if (!open) setEditingBrand(null); }}
      />
    </div>
  );
}
